/**
 * Phase 0 · Infra-1 — web build stub for the in-app video call screen.
 *
 * The mobile call screen depends on `react-native-agora`, which is a
 * native-only module. Web sponsors have a dedicated, self-contained client
 * served at `public/meet.html` (route: GET /meet/:channel) — they never
 * hit the in-app route on web.
 *
 * Metro picks `.web.tsx` over `.tsx` for the web bundle, so this file
 * keeps the web build clean of any Agora imports.
 */

import React from 'react';
import { View, Text, StyleSheet, SafeAreaView } from 'react-native';

export default function VideoCallWebStubScreen() {
  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.content}>
        <Text style={styles.title}>Use o aplicativo Padrinho</Text>
        <Text style={styles.body}>
          Videochamadas são feitas pelo aplicativo no seu celular. Abra o
          Padrinho no iPhone ou Android para entrar na sessão.
        </Text>
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#F9F8F3' },
  content: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 32,
    gap: 12,
  },
  title: {
    color: '#015480',
    fontFamily: 'InstrumentSerif_400Regular',
    fontSize: 32,
    lineHeight: 36,
    textAlign: 'center',
  },
  body: {
    color: '#151515',
    fontFamily: 'Inter_400Regular',
    fontSize: 14,
    lineHeight: 20,
    textAlign: 'center',
  },
});
